export default __webpack_public_path__ + "static/media/caution.8ff4e91a.png";